import * as React from "react";
import {BaseFormViewState, default as BaseFormView} from "../../../../ui/form/BaseFormView";
import FormButtonsView from "../../../../ui/form/FormButtonsView";
import ButtonPrimary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import Task from "../../../../../model/task/Task";
import TaskForm from "../TaskForm";
import TaskFormBody from "../TaskFormBody";

interface IComponentProps {
	/**
	 * On submit callback. Should call only when form is valid.
	 * @param {Task} data
	 */
	onSubmit: (data: Task) => void;
	/**
	 * On cancel button handler.
	 */
	onCancel: () => void;
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
	/**
	 * Task to edit
	 */
	task: Task;
}

type IState = BaseFormViewState<TaskForm>;

export default class EditTaskFormView extends BaseFormView<TaskForm, IComponentProps, IState> {
	constructor(props: IComponentProps) {
		super(props);
		this.state = {
			form: TaskForm.createFromTask(this.props.task),
			isFormDirty: false,
			shouldValidate: false
		};
	}

	render() {
		return (
			<div>
				<TaskFormBody form={this.state.form}
							  onFieldChange={this.onFieldChanged}
							  onFieldCompleted={this.onFieldCompleted}
							  onFocusChange={this.onFocusChange}
							  onFieldsChange={this.onFieldsChanged}/>
				<FormButtonsView align={"right"}>
					<ButtonTertiary onClick={this.props.onCancel}
									label={"Cancel"}
									disabled={this.props.isSubmitting}/>
					<ButtonPrimary onClick={() => this.submitForm()}
								   label={"Update task"}
								   disabled={this.props.isSubmitting}
								   isLoading={this.props.isSubmitting}/>
				</FormButtonsView>
			</div>
		);
	}

	submitForm(): void {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onValid(this.props.onSubmit);
		});
	}
}